import get from 'lodash/get';
import TemplateStore from '../../templates/template-store';
import templateInterrogator from '../../misc/template-interrogator';
import prismItemInterrogator from '../../misc/prism-item-interrogator';
import { useTemplateSelectStore } from 'stores/useTemplateStore';

class Shuffle {
  static get can() {
    if (!get(window, ['activeView', 'template', 'photo_slots'])) {
      return false;
    }

    return Shuffle.layouts.length > 1;
  }

  static do() {
    if (!this.can) return;

    useTemplateSelectStore.getState().updateTemplateSelectStore({
      templateID: activeView.template.id,
      orientation: Shuffle.activeViewOrientation,
      shuffle: true,
      layouts: Shuffle.layouts,
    });
  }

  static get photoSlotCount() {
    return Object.keys(activeView.template.photo_slots).filter(
      k => k !== 'optional-bg'
    ).length;
  }

  static get activeViewOrientation() {
    return TemplateStore.getOrientation(activeView.template.size);
  }

  static get layouts() {
    const orientationFilter = templateInterrogator.orientationFilter(
      activeView.template
    );
    const wrapFilter = templateInterrogator.wrapFilter(activeView.template);

    const result = TemplateStore.templatesFiltered({
      noOfPhotos: Shuffle.photoSlotCount,
      section: prismItemInterrogator.getCurrentSection(),
      orientations: orientationFilter,
      wraps: wrapFilter,
    });

    return result;
  }

  static get nextLayout() {
    const layouts = Shuffle.layouts;

    if (!layouts || layouts.length === 0) {
      return null;
    } else if (layouts.length === 1) {
      return layouts[0];
    }

    const currentLayoutIndex = layouts.findIndex(
      layout => layout.id === activeView.template.id
    );
    const nextLayoutIndex =
      currentLayoutIndex < layouts.length - 1 ? currentLayoutIndex + 1 : 0;

    return layouts[nextLayoutIndex];
  }
}

// --------------------------------------------------------------------

export default Shuffle;
